import { LupaIcon } from "assets/icons/LupaIcon";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Pagination } from "components/Pagination/Pagination";
import { Select } from "components/Select/Select";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchEstados,
  fetchEstadosValidacionNacional,
} from "store/slices/appSlice";
import { AppDispatch, RootState } from "store/store";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { getValidezNacional } from "services/validezNacional";
import { ValidezNacionalRowActions } from "./ValidezNacionalTable/ValidezNacionalRowActions";
import { ValidacionNacionalABM } from "./ValidezNacionalABM/ValidezNacionalABM";
import { ValidezNacionalTable } from "./ValidezNacionalTable/ValidezNacionalTable";

export const ValidezNacional = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [elementos, setElementos] = useState<ValidezNacionalI[]>();
  const [cantidad, setCantidad] = useState<number>();
  const [page, setPage] = useState<number>();
  const [limit, setLimit] = useState<number>();

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { estadosValidacionNacional, loadingAppData } = useSelector(
    (st: RootState) => st.appData,
  );

  const [showModalABM, setShowModalABM] = useState(false);
  const [actionType, setActionType] = useState<"create" | "edit" | undefined>();
  const [selectedElement, setSelectedElement] = useState<
    ValidezNacionalI | undefined
  >();

  const initialValues = {
    nombre: "",
    estado_id: "",
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const searchValidezNacional = async (params?: {
    filtros?: { [key: string]: any };
  }) => {
    try {
      setIsLoading(true);
      const response = await getValidezNacional({ ...params?.filtros });
      setElementos(response.elementos);
      setCantidad(response.cantidad);
      setPage(response.page);
      setLimit(params?.filtros?.limit ?? DEFAULT_LIMIT_PAGINATION);
    } catch (err) {
      showErrorToast("No fue posible cargar las validaciones nacionales");
    } finally {
      setIsLoading(false);
    }
  };

  const refreshTable = () => {
    setPage(1);
    searchValidezNacional({ filtros: { ...values, page: 1 } });
  };

  const handleCloseModal = () => {
    setShowModalABM(false);
    setTimeout(() => setActionType(undefined), 500);
  };

  const handleEdit = (elemento: ValidezNacionalI) => {
    setActionType("edit");
    setSelectedElement(elemento);
    setShowModalABM(true);
  };

  const handleCreate = () => {
    setActionType("create");
    setShowModalABM(true);
  };

  const handleChangePagination = (newFiltros: {
    [key: string]: string | number;
  }) => {
    searchValidezNacional({ filtros: { ...values, ...newFiltros } });
  };

  const handleClearFilters = () => {
    resetForm();
    searchValidezNacional({ filtros: {} });
  };

  const handleChangeWithResetPage = (pageOne: any) => {
    setPage(1);
    handleChange(pageOne);
  };

  const renderActions = (
    elemento: ValidezNacionalI,
    onClickShowDetail: (elemento: ValidezNacionalI) => void,
  ) => {
    return (
      <ValidezNacionalRowActions
        elemento={elemento}
        onClickEdit={handleEdit}
        onClickShowDetail={onClickShowDetail}
        refreshTable={refreshTable}
      />
    );
  };

  useEffect(() => {
    searchValidezNacional({ filtros: { ...values, limit, page } });
  }, [values]);

  useEffect(() => {
    if (!estadosValidacionNacional) dispatch(fetchEstadosValidacionNacional());
  }, []);

  return (
    <section>
      <h1 className="section-title">Validez Nacional</h1>

      <h2 className="section-subtitle mt-2">
        Desde acá podrás gestionar las valideces nacionales.
      </h2>

      <div className="d-flex justify-content-between mt-4 mb-3">
        <div className="d-flex column-gap-3">
          {/* <Input
            size="sm"
            id="nombre"
            onChange={handleChangeWithResetPage}
            placeholder="Buscar"
            values={values}
            startIcon={<LupaIcon />}
          /> */}
          <Select
            id="estado_id"
            values={values}
            onChange={handleChangeWithResetPage}
            optionsFormatConfig={{ value: "id", label: "nombre" }}
            options={estadosValidacionNacional ?? []}
            isLoading={loadingAppData.estadosValidacionNacional}
            placeholder="Estado"
            width="145px"
          />
          <Button
            size="sm"
            variant="secondary"
            className="clear-filters-button"
            onClick={handleClearFilters}
            disabled={!values.nombre && !values.estado_id}
          >
            Limpiar filtros
          </Button>
        </div>
        <Button size="lg" onClick={handleCreate}>
          Nueva Validez Nacional
        </Button>
        <ValidacionNacionalABM
          showModal={showModalABM}
          actionType={actionType}
          onClose={handleCloseModal}
          elemento={selectedElement}
          onSuccess={refreshTable}
        />
      </div>

      {isLoading && (
        <div className="d-flex justify-content-center w-full">
          <Spinner />
        </div>
      )}

      {!isLoading && elementos && cantidad != undefined && (
        <>
          <ValidezNacionalTable
            elementos={elementos}
            renderActions={renderActions}
          />
          <Pagination
            totalItems={cantidad}
            currentPage={page}
            currentLimit={limit}
            onChangePage={handleChangePagination}
            showPaginationOnlyOnMoreThanPages={1}
          />
        </>
      )}
    </section>
  );
};
